<template>
    <v-dialog v-model="dialog" max-width="85vh" width="85%" :disabled="!src">
        <template v-slot:activator="{ attrs, on }">
            <slot v-if="hasCustomActivator" name="activator" v-bind="{ attrs, on }" />
            <v-avatar v-else v-bind="{ ...attrs, ...avatarAttrs }" v-on="on" :style="!src ? 'cursor:initial' : ''">
                <v-img v-bind="{ src }">
                    <template v-slot:placeholder>
                        <v-icon dark>mdi-image</v-icon>
                    </template>
                </v-img>
            </v-avatar>
        </template>

        <v-card dark>
            <v-img v-if="src" v-bind="{ src }" eager>
                <v-card-title v-if="title" style="background-color: rgba(0, 0, 0, 0.3) !important">
                    {{ title }} <v-spacer />
                    <v-icon @click="dialog = false">mdi-close</v-icon>
                </v-card-title>
                <v-btn v-else absolute right top icon tile dark x-large @click="dialog = false" style="background-color: rgba(0, 0, 0, 0.3)">
                    <v-icon size="4rem">mdi-close</v-icon>
                </v-btn>
            </v-img>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        size: { type: String, default: null },
        src: { type: String, default: undefined },
        title: { type: String, default: null },
        width: { type: String, default: null },
        height: { type: String, default: null },
        rounded: { type: Boolean, default: false },
        hasCustomActivator: { type: Boolean, default: false },
    },
    computed: {
        avatarAttrs() {
            const { size, width, height, rounded } = this;
            return {
                size,
                width,
                height,
                tile: !rounded,
                rounded,
                color: "grey lighten-1",
            };
        },
    },
    data() {
        return { dialog: false };
    },
};
</script>

<style></style>
